/**
 * Atualização do PWA.
 *
 * `skipWaiting` está desligado no service worker: uma versão nova não substitui a
 * antiga no meio de um fluxo. Trocar o JavaScript sob os pés de quem está
 * digitando um código 2FA ou aprovando um modelo de ingestão é uma forma barata de
 * perder trabalho. Em vez disso, avisamos e deixamos a pessoa recarregar.
 */
import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from 'sonner';

export function AvisoAtualizacao() {
  const {
    needRefresh: [precisaAtualizar],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    if (!precisaAtualizar) return;
    toast('Uma versão nova do bHunter está pronta.', {
      duration: Infinity,
      action: { label: 'Atualizar', onClick: () => void updateServiceWorker(true) },
    });
  }, [precisaAtualizar, updateServiceWorker]);

  return null;
}
